import React from "react";
import "./Footer.css";
// import { FaFacebookF, FaTwitter, FaYoutube } from "react-icons/fa";
// import { BiLogoBlogger } from "react-icons/bi";

const Footer = () => {
  return (
    <footer className="footer">
      <p className="text-center m-0 footer-text"><a href="https://www.litostindia.in/">Designed by @Litost India</a></p>
      {/* <div className="footer-container">
        About Section
        <div className="footer-section">
          <h3>ABOUT US</h3>
          <p className="text-light">
          We don’t just provide milk; we offer a healthier lifestyle, rooted in the wisdom of nature and sustainability. Join us in our journey towards a healthier, happier community!
          </p>
          <div className="social-icons">
            <a href="#/"><FaFacebookF /></a>
            <a href="#/"><FaTwitter /></a>
            <a href="#/"><BiLogoBlogger /></a>
            <a href="#/"><FaYoutube /></a>
          </div>
        </div> */}

        {/* Services Section */}
        {/* <div className="footer-section">
          <h3>SERVICES</h3>
          <ul>
            <li>A2 Cow Milk</li>
          </ul>
        </div> */}

        {/* Business Hours Section */}
        {/* <div className="footer-section">
          <h3>BUSINESS HOURS</h3>
          <p><strong>Mon - Fri:</strong> 10:00 am - 06:00 pm</p>
          <p><strong>Saturday (1st & 4th):</strong> 08:00 am - 04:00 pm</p>
          <p><strong>Emergency Service:</strong> +91 9811145511</p>
        </div> */}

        {/* Subscribe Section */}
        {/* <div className="footer-section">
          <h3>SUBSCRIBE US</h3>
          <p>Subscribe us & receive our office updates in your inbox directly.</p>
          <div className="subscribe-box">
            <input type="email" placeholder="info@webmail.com" />
            <button>SUBSCRIBE NOW</button>
          </div>
        </div> */}
      {/* </div> */}
    </footer>
  );
};

export default Footer;
